var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLungs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_2527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6216 7.98172C13.1951 7.98172 13.1252 7.51842 13.1252 6.63023V1.78186C13.1252 1.16151 12.6204 0.656738 12.0001 0.656738C11.3797 0.656738 10.8749 1.16151 10.8749 1.78186V6.63023C10.8749 7.51842 10.805 7.98172 9.3781 7.98172C9.27442 7.98172 9.18726 8.06562 9.18726 8.1693V10.0446C9.18726 10.1482 9.27519 10.2321 9.37887 10.2321C10.4934 10.2321 11.3755 9.97659 11.9995 9.47221C12.6237 9.97659 13.5072 10.2321 14.6216 10.2321C14.7253 10.2321 14.8128 10.1482 14.8128 10.0446V8.1693C14.8128 8.06562 14.7253 7.98172 14.6216 7.98172Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84114 12.988C9.70905 11.8026 9.57292 10.5763 9.57292 9.38818C9.57292 6.37283 9.24287 2.36426 6.39168 2.36426C2.92512 2.36426 0.000200535 11.5683 0.000200535 17.3477C-0.00114346 17.5301 -0.0224555 21.8299 1.15508 23.0169C1.36973 23.2331 1.61434 23.3429 1.88256 23.3429C2.59124 23.3429 2.94355 23.0722 3.43143 22.698C4.04352 22.2282 4.88141 21.5846 7.0078 20.9715C10.6128 19.932 10.2382 16.5594 9.84114 12.988Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 17.3493C23.9997 11.5685 21.075 2.36426 17.6086 2.36426C14.757 2.36426 14.4276 6.37283 14.4276 9.38818C14.4276 10.5763 14.2912 11.8024 14.1595 12.988C13.7625 16.5594 13.3875 19.932 16.9929 20.9715C19.1189 21.5846 19.957 22.2282 20.5689 22.6976C21.0567 23.0722 21.4091 23.3429 22.1177 23.3429C22.3858 23.3429 22.6304 23.2331 22.845 23.0169C24.0224 21.8299 24.0012 17.5303 23.9997 17.3493Z",
    fill: "#C59C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_2527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/lungs.0e37acfe0d4190e92d9e5159381d5ab7.svg";
export { ForwardRef as ReactComponent };